__turbopack_context__.v({
  "backArrowImg": "index-module__4e6RiW__backArrowImg",
  "backBtn": "index-module__4e6RiW__backBtn",
  "backButton": "index-module__4e6RiW__backButton",
  "boldText": "index-module__4e6RiW__boldText",
  "breadcrumbs": "index-module__4e6RiW__breadcrumbs",
  "cascader": "index-module__4e6RiW__cascader",
  "cascaderProduct": "index-module__4e6RiW__cascaderProduct",
  "cascaderv2": "index-module__4e6RiW__cascaderv2",
  "container": "index-module__4e6RiW__container",
  "itemsSelector": "index-module__4e6RiW__itemsSelector",
  "text": "index-module__4e6RiW__text",
  "underlined": "index-module__4e6RiW__underlined",
});
